import { render } from "./IconFolder.vue?vue&type=template&id=3a88d72b"
import script from "./IconFolder.vue?vue&type=script&lang=js"
export * from "./IconFolder.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__